import {l} from "../debug/debug";
import {Layouts} from "../../../layouts/layouts";
import {EventDispatcher} from "../events";
import {Header} from "../../../templates/header/Header";
import {SkipToContent} from "./SkipToContent";

import {ContentToggleButton} from "./modules/ContentToggleButton";
import {AnchorLink} from "./modules/AnchorLink";
import {SingleProduct} from "../../../templates/single-product/SingleProduct";
import * as lightbox from 'lightbox2';
import {GeoPopup} from "../../../templates/geo-popup/GeoPopup";


export class Site extends EventDispatcher {

    private layouts: Layouts;
    private header: Header;

    private product: SingleProduct;

    private readonly SELECTOR_CONTENT: string = "#content";
    private readonly SKIP_TO_CONTENT_LINKTEXT: string = 'Skip to content';
    private readonly SELECTOR_HEADER: string = 'header.header';

    private readonly SELECTOR_SINGLE_PRODUCT: string = "article.single-product";
    private readonly SELECTOR_ARTICLE_EMBED: string = ".article-content iframe";

    private skipToContent: SkipToContent;

    private geoPopup: GeoPopup;


    private windowHash: string;

    constructor() {
        super();
        l('site init');
        this.header = new Header();
        this.layouts = new Layouts();
        this.skipToContent = new SkipToContent(this.SELECTOR_CONTENT, this.SKIP_TO_CONTENT_LINKTEXT, this.SELECTOR_HEADER);
        this.geoPopup = new GeoPopup();

        if ($(this.SELECTOR_SINGLE_PRODUCT).length == 1) {
            this.product = new SingleProduct($(this.SELECTOR_SINGLE_PRODUCT));
        }

        this.windowHash = location.hash;
        if (this.windowHash) {
            location.hash = "";
        }

        lightbox.option({
            'imageFadeDuration': 700,
            'fadeDuration': 350,
            'resizeDuration': 700,
            'wrapAround': true,
            'disableScrolling': true,
        });


        $("a.content-toggle-button").each(function (index, element) {
            new ContentToggleButton($(element));
        });


        $('a[href*="#"]').not('.no-scroll').each(function (index, element) {

            console.log(element);
            new AnchorLink($(element));
        });

        $(this.SELECTOR_ARTICLE_EMBED).each(function () {
            $(this).removeAttr('height').removeAttr('width');
            $(this).parent().addClass('contains-video');
            $(this).wrap('<div class="embed-container"></div>');

        });


        if (this.windowHash) {
            window.scrollTo(0, 0);
            console.log(this.windowHash);
            setTimeout(() => this.scrollToTarget(), 1);

        }


    }

    private scrollToTarget() {
        console.log('scrolling to target: ' + this.windowHash);
        const targetTop = $(this.windowHash).offset().top - 100;
        $('html, body').stop().animate({scrollTop: targetTop});
    }


}